import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  BentoHoldingsIcon,
  BentoIdentityIcon,
  BentoInvestorsIcon,
  BentoLandingIcon,
  classNames,
} from '@groma-dev/blueprint';
import { BentoPanel as BP, BentoItemLink } from '@groma-dev/navigation';
import { FormattedMessage } from 'react-intl';
import { AppConfig } from '../../../../core/AppConfig';
import styles from './BentoPanel.module.scss';

export interface BentoPanelProps {
  open: boolean;
  onClose: () => void;
}

export const BentoPanel = observer((props: BentoPanelProps) => {
  const { open, onClose } = props;
  const { Domains } = AppConfig.Settings;

  return (
    <BP className={classNames(styles.bentoPanel)} open={open} disableScroll testId="bentoPanel" onClose={onClose}>
      <div className={classNames(styles.grid)}>
        <BentoItemLink href={Domains.investors.baseUrl} className={classNames(styles.bentoItem)}>
          <BentoInvestorsIcon />
          <FormattedMessage
            id="header.bentoPanel.itemLink.investors"
            defaultMessage="Investor Portal"
            description="Bento Panel inventors link"
          />
        </BentoItemLink>
        <BentoItemLink href={Domains.holdings.baseUrl} className={classNames(styles.bentoItem)}>
          <BentoHoldingsIcon />
          <FormattedMessage
            id="header.bentoPanel.itemLink.holdings"
            defaultMessage="GromaBase"
            description="Bento Panel holdings link"
          />
        </BentoItemLink>
        <BentoItemLink href={Domains.id.baseUrl} className={classNames(styles.bentoItem)}>
          <BentoIdentityIcon />
          <FormattedMessage
            id="header.bentoPanel.itemLink.identity"
            defaultMessage="Profile"
            description="Bento Panel identity link"
          />
        </BentoItemLink>
        <BentoItemLink href={Domains.landing.baseUrl} className={classNames(styles.bentoItem)}>
          <BentoLandingIcon />
          <FormattedMessage
            id="header.bentoPanel.itemLink.landing"
            defaultMessage="Groma.com"
            description="Bento Panel Landing link"
          />
        </BentoItemLink>
      </div>
    </BP>
  );
});
